(() => {
  const shades = [
    { n: '01', name: 'Espresso Brown', color: 'var(--shade-espresso-brown)', ink: '#fff', mood: 'Everyday depth', copy: 'A warm brown for softer definition and easy everyday eyes.' },
    { n: '02', name: 'Soft Nude', color: 'var(--shade-soft-nude)', ink: '#11110f', mood: 'Soft contrast', copy: 'A muted nude that brightens and adds subtle contrast.' },
    { n: '03', name: 'Tropical Aqua', color: 'var(--shade-tropical-aqua)', ink: '#fff', mood: 'Fresh energy', copy: 'A bright aqua that makes simple looks feel instantly fresher.' },
    { n: '04', name: 'Royal Blue', color: 'var(--shade-royal-blue)', ink: '#fff', mood: 'Electric impact', copy: 'The blue that turns a simple eye into the whole look.' },
    { n: '05', name: 'Snow White', color: 'var(--shade-snow-white)', ink: '#11110f', mood: 'Clean contrast', copy: 'A crisp white for graphic details, highlights and bold contrast.' },
    { n: '06', name: 'Rich Black', color: 'var(--shade-rich-black)', ink: '#fff', mood: 'Classic intensity', copy: 'The deep black you reach for when the eyes need definition.' },
    { n: '07', name: 'Electric Green', color: 'var(--shade-electric-green)', ink: '#fff', mood: 'High voltage', copy: 'A saturated green that brings colour without losing definition.' },
  ];

  const money = (paise) => `₹${Math.round(Number(paise || 0) / 100).toLocaleString('en-IN')}`;
  const normal = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));

  class FeeoStorefront {
    constructor(root) {
      this.root = root;
      this.quantity = 1;
      this.galleryIndex = 0;
      this.variants = this.readVariants();
      this.combo = this.readCombo();
      this.comboSelected = false;
      this.productImages = this.readProductImages();
      this.shadeFeatureImages = this.readShadeFeatureImages();
      this.homeHeroImages = this.readHomeHeroImages();
      this.homeShadeImages = this.readHomeShadeImages();
      this.giftCampaign = this.readGiftCampaign();
      this.giftSyncing = false;
      this.selected = this.initialShade();
      this.currentGalleryItems = [];
      this.assetBase = this.findAssetBase();
      this.bind();
      this.setupMotion();
      this.setupBannerSlider();
      this.setupShoppableVideos();
      this.setupReviews();
      this.setupContactSuccess();
      this.refreshCart();
      if (this.root.querySelector('.home-hero .hero-shades')) this.selected = shades[0];
      this.renderShade();
      this.setupHomeHeroAutoplay();
    }

    readVariants() {
      const node = this.root.querySelector('[data-feeo-variants]');
      if (!node) return [];
      try {
        const variants = JSON.parse(node.textContent);
        const idNode = document.querySelector('[data-feeo-variant-ids]');
        const exactIds = idNode ? JSON.parse(idNode.textContent) : {};
        return variants.map((variant) => ({ ...variant, id: exactIds[variant.title] || variant.id }));
      } catch (_) { return []; }
    }

    readCombo() {
      const node = this.root.querySelector('[data-feeo-combo]');
      if (!node) return null;
      try { return JSON.parse(node.textContent); } catch (_) { return null; }
    }

    readProductImages() {
      const node = document.querySelector('[data-feeo-product-images]');
      if (!node) return [];
      try { return JSON.parse(node.textContent); } catch (_) { return []; }
    }

    readShadeFeatureImages() {
      const node = document.querySelector('[data-feeo-shade-feature-images]');
      if (!node) return {};
      try { return JSON.parse(node.textContent); } catch (_) { return {}; }
    }

    readHomeHeroImages() {
      const node = this.root.querySelector('[data-feeo-home-hero-images]');
      if (!node) return {};
      try { return JSON.parse(node.textContent); } catch (_) { return {}; }
    }

    readHomeShadeImages() {
      const node = this.root.querySelector('[data-feeo-home-shade-images]');
      if (!node) return {};
      try { return JSON.parse(node.textContent); } catch (_) { return {}; }
    }

    readGiftCampaign() {
      const node = document.querySelector('[data-feeo-gift-campaign]');
      if (!node) return null;
      try { return JSON.parse(node.textContent); } catch (_) { return null; }
    }

    initialShade() {
      const defaultId = String(this.root.dataset.defaultVariant || '');
      const variant = this.variants.find((item) => String(item.id) === defaultId) || this.variants[0];
      return shades.find((shade) => normal(`${variant?.title || ''} ${variant?.option1 || ''}`).includes(normal(shade.name))) || shades[3];
    }

    findAssetBase() {
      const img = this.root.querySelector('img[src*="product-horizontal-cutout"]');
      if (!img) return '';
      try {
        const url = new URL(img.src, window.location.href);
        url.search = '';
        url.hash = '';
        return url.href.slice(0, url.href.lastIndexOf('/') + 1);
      } catch (_) {
        return img.src.slice(0, img.src.lastIndexOf('/') + 1);
      }
    }

    asset(name) {
      try { return new URL(name, this.assetBase || window.location.href).href; }
      catch (_) { return `${this.assetBase}${name}`; }
    }

    bind() {
      this.root.querySelectorAll('.menu-trigger').forEach((button) => button.addEventListener('click', () => this.toggleMenu()));
      this.root.querySelectorAll('.mobile-menu a').forEach((link) => link.addEventListener('click', () => this.toggleMenu(false)));
      this.root.querySelectorAll('.bag-button').forEach((button) => button.addEventListener('click', () => this.toggleCart(true)));
      this.root.querySelectorAll('.cart-backdrop, .cart-head button').forEach((button) => button.addEventListener('click', () => this.toggleCart(false)));

      const shadeButtons = this.root.querySelectorAll('.hero-shades button, .shade-tabs button, .pdp-shades [data-feeo-shade-select], .pdp-mobile-shade-dots button, .shade-guide-rail button');
      shadeButtons.forEach((button) => button.addEventListener('click', () => {
        const label = button.dataset.shadeName || button.querySelector('b')?.textContent || button.textContent;
        const shade = shades.find((item) => normal(label).includes(normal(item.name)));
        if (shade) {
          this.comboSelected = false;
          this.selected = shade;
          this.galleryIndex = 0;
          this.renderShade();
        }
      }));

      this.root.querySelectorAll('[data-feeo-combo-select]').forEach((button) => button.addEventListener('click', () => this.selectCombo(button)));
      this.root.querySelectorAll('[data-feeo-combo-add]').forEach((button) => button.addEventListener('click', () => this.addComboToCart(button)));
      this.root.querySelectorAll('[data-feeo-shade-add]').forEach((button) => button.addEventListener('click', () => this.addShadeCardToCart(button)));

      this.root.querySelectorAll('[data-feeo-add]').forEach((button) => button.addEventListener('click', () => this.addToCart(false, button)));
      this.root.querySelectorAll('[data-feeo-buy-now]').forEach((button) => button.addEventListener('click', () => this.addToCart(true, button)));

      const minus = this.root.querySelector('.quantity button:first-child');
      const plus = this.root.querySelector('.quantity button:last-child');
      minus?.addEventListener('click', () => this.setQuantity(this.quantity - 1));
      plus?.addEventListener('click', () => this.setQuantity(this.quantity + 1));

      const prev = this.root.querySelector('.gallery-control-bar button:first-child');
      const next = this.root.querySelector('.gallery-control-bar button:last-child');
      prev?.addEventListener('click', () => this.setGallery(this.galleryIndex - 1));
      next?.addEventListener('click', () => this.setGallery(this.galleryIndex + 1));
      this.root.querySelector('.gallery-thumbs')?.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-gallery-index]');
        if (button) this.setGallery(Number(button.dataset.galleryIndex));
      });

      this.root.querySelectorAll('details').forEach((detail) => detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        detail.parentElement?.querySelectorAll('details[open]').forEach((open) => { if (open !== detail) open.open = false; });
      }));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { this.toggleMenu(false); this.toggleCart(false); }
      });
      this.setupProductNav();
    }

    variantForShade() {
      if (this.comboSelected && this.combo) return this.combo;
      const shadeKey = normal(this.selected.name);
      return this.variants.find((variant) => normal(`${variant.title} ${variant.option1}`).includes(shadeKey))
        || this.variants.find((variant) => variant.available)
        || this.variants[0]
        || { id: String(this.root.dataset.defaultVariant || ''), available: true, price: 0, compare_at_price: 0 };
    }

    selectCombo(button) {
      if (!this.combo?.id) {
        this.toast('Choose the full set product in the theme editor first.');
        return;
      }
      this.comboSelected = true;
      this.root.querySelectorAll('.hero-shades button, .shade-tabs button, .pdp-shades [data-feeo-shade-select], .pdp-mobile-shade-dots button, .shade-guide-rail button').forEach((shadeButton) => {
        shadeButton.classList.remove('active');
        if (shadeButton.getAttribute('role') === 'radio') shadeButton.setAttribute('aria-checked', 'false');
        if (shadeButton.getAttribute('role') === 'tab') shadeButton.setAttribute('aria-selected', 'false');
      });
      this.root.querySelectorAll('[data-feeo-combo-select]').forEach((comboButton) => {
        const active = comboButton === button || this.root.querySelectorAll('[data-feeo-combo-select]').length === 1;
        comboButton.classList.toggle('active', active);
        comboButton.setAttribute('aria-pressed', String(active));
      });
      const label = this.root.querySelector('.shade-label b');
      if (label) label.textContent = this.combo.labels?.all_seven || 'All 7 Smoke X shades';
      const mobileName = this.root.querySelector('.mobile-buy-product b');
      if (mobileName) mobileName.textContent = `Smoke X · ${this.combo.labels?.full_set || 'Full Spectrum Set'}`;
      this.galleryIndex = 0;
      this.updatePriceLabels();
      if (this.root.classList.contains('product-page')) this.refreshGallery();
    }

    async addComboToCart(button) {
      if (!this.combo?.id) {
        this.toast('Choose the full set product in the theme editor first.');
        return;
      }
      await this.addShoppableVideoToCart(this.combo.id, this.combo.labels?.all_seven || 'All 7 Smoke X shades', button);
    }

    setQuantity(value) {
      this.quantity = Math.max(1, Math.min(10, value));
      const count = this.root.querySelector('.quantity b');
      if (count) count.textContent = String(this.quantity);
      this.updatePriceLabels();
    }

    updatePriceLabels() {
      const variant = this.variantForShade();
      const unit = Number(variant.price || 0);
      const compareAt = Number(variant.compare_at_price || 0);
      const saving = Math.max(0, compareAt - unit);
      const onSale = unit > 0 && compareAt > unit;

      this.root.querySelectorAll('.add-button').forEach((button) => {
        button.textContent = `Add to bag · ${money(unit * this.quantity)}`;
      });
      this.root.querySelectorAll('[data-feeo-quick-add]').forEach((button) => {
        button.textContent = `Quick add · ${money(unit)}`;
      });
      this.root.querySelectorAll('[data-feeo-unit-price], [data-feeo-price-current]').forEach((node) => {
        node.textContent = money(unit);
      });
      this.root.querySelectorAll('[data-feeo-price-compare]').forEach((node) => {
        node.textContent = money(compareAt);
      });
      this.root.querySelectorAll('[data-feeo-price-compare-wrap], [data-feeo-price-saving]').forEach((node) => {
        node.hidden = !onSale;
      });
      this.root.querySelectorAll('[data-feeo-price-save]').forEach((node) => {
        node.textContent = money(saving);
      });
      this.root.querySelectorAll('[data-feeo-price-panel]').forEach((panel) => {
        panel.classList.toggle('is-sale', onSale);
      });
    }

    renderShade() {
      if (this.root.hasAttribute('data-feeo-generic-product')) {
        this.updatePriceLabels();
        if (this.root.classList.contains('product-page')) this.refreshGallery();
        return;
      }
      const s = this.selected;
      if (!this.comboSelected) {
        this.root.querySelectorAll('[data-feeo-combo-select]').forEach((button) => {
          button.classList.remove('active');
          button.setAttribute('aria-pressed', 'false');
        });
      }
      const allShadeButtons = this.root.querySelectorAll('.hero-shades button, .shade-tabs button, .pdp-shades [data-feeo-shade-select], .pdp-mobile-shade-dots button, .shade-guide-rail button');
      allShadeButtons.forEach((button) => {
        const buttonShade = button.dataset.shadeName || button.querySelector('b')?.textContent || button.textContent;
        const active = normal(buttonShade) === normal(s.name);
        button.classList.toggle('active', active);
        if (button.getAttribute('role') === 'radio') button.setAttribute('aria-checked', String(active));
        if (button.getAttribute('role') === 'tab') button.setAttribute('aria-selected', String(active));
      });

      const hero = this.root.querySelector('.hero-visual');
      if (hero) {
        hero.style.background = s.color;
        hero.style.color = s.ink;
        const heroImage = hero.querySelector('[data-home-hero-image]');
        const configuredHeroImage = this.homeHeroImages[s.name] || '';
        const nextHeroImage = configuredHeroImage || hero.dataset.fallbackSrc || heroImage?.src;
        hero.classList.toggle('has-shade-creative', Boolean(configuredHeroImage));
        if (heroImage && nextHeroImage) {
          heroImage.classList.toggle('hero-campaign-image', Boolean(configuredHeroImage));
          heroImage.classList.remove('is-revealing');
          if (heroImage.src !== nextHeroImage) heroImage.src = nextHeroImage;
          heroImage.alt = `FEEO Beauty Smoke X ${s.name} creative`;
          window.requestAnimationFrame(() => heroImage.classList.add('is-revealing'));
        }
      }
      const heroText = this.root.querySelector('.hero-shade');
      if (heroText) heroText.innerHTML = `<b>${s.name}</b><span>${s.mood}</span>`;

      const stage = this.root.querySelector('.shade-stage');
      if (stage) {
        stage.style.background = s.color;
        stage.style.color = s.ink;
        const kicker = stage.querySelector('[data-shade-stage-kicker]');
        if (kicker) kicker.textContent = `Smoke X · ${s.mood}`;
        const stageTitle = stage.querySelector('h3');
        if (stageTitle) stageTitle.textContent = s.name;
        const stageCopy = stage.querySelector('p');
        if (stageCopy) stageCopy.textContent = s.copy;
        const stageImage = stage.querySelector('[data-home-shade-image]');
        if (stageImage) {
          const nextImage = this.homeShadeImages[s.name] || stage.dataset.fallbackSrc || stageImage.src;
          stageImage.classList.remove('is-revealing');
          if (stageImage.src !== nextImage) stageImage.src = nextImage;
          stageImage.alt = `Smoke X ${s.name} pencil`;
          window.requestAnimationFrame(() => stageImage.classList.add('is-revealing'));
        }
      }

      const label = this.root.querySelector('.shade-label b');
      if (label) label.textContent = s.name;
      const mobileName = this.root.querySelector('.mobile-buy-product b');
      if (mobileName) mobileName.textContent = `Smoke X · ${s.name}`;

      const feature = this.root.querySelector('.shade-feature');
      if (feature) {
        feature.style.removeProperty('background');
        feature.style.setProperty('--shade-feature-color', s.color);
        feature.style.setProperty('--shade-feature-ink', s.ink);
        feature.style.color = s.ink;
        const title = feature.querySelector('h3'); if (title) title.textContent = s.name;
        const copy = feature.querySelector('p'); if (copy) copy.textContent = s.copy;
        const productStage = feature.querySelector('[data-shade-feature-product]');
        const productImage = feature.querySelector('[data-shade-feature-image]');
        const uploadNote = feature.querySelector('.shade-feature-upload-note');
        const featureImageUrl = this.shadeFeatureImages[s.name];
        if (productStage && productImage) {
          productStage.dataset.shadeLabel = s.name;
          productStage.classList.toggle('is-empty', !featureImageUrl);
          if (featureImageUrl) {
            productImage.src = featureImageUrl;
            productImage.alt = `Smoke X ${s.name} pencil`;
            productImage.hidden = false;
          } else {
            productImage.removeAttribute('src');
            productImage.alt = '';
            productImage.hidden = true;
          }
        }
        if (uploadNote) uploadNote.textContent = `Upload the ${s.name} pencil cutout`;
      }
      this.updatePriceLabels();
      if (this.root.classList.contains('product-page')) this.refreshGallery();
    }

    variantGalleryImages() {
      if (this.root.hasAttribute('data-feeo-generic-product')) {
        return this.productImages
          .filter((image) => image?.url)
          .map((image) => ({ kind: 'shopify', src: image.url, alt: image.alt || this.root.dataset.productTitle || 'Product image', fit: 'shopify' }));
      }
      if (this.comboSelected && this.combo) {
        const comboImages = Array.isArray(this.combo.images) && this.combo.images.length
          ? this.combo.images
          : (this.combo.image ? [{ url: this.combo.image, alt: this.combo.labels?.full_set || 'All 7 Shades Combo' }] : []);
        return comboImages
          .filter((image) => image?.url)
          .map((image) => ({
            kind: 'shopify',
            src: image.url,
            alt: image.alt || this.combo.labels?.full_set || 'All 7 Shades Combo',
            fit: 'shopify',
          }));
      }
      const escapedShadeName = this.selected.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const galleryAltPattern = new RegExp(`^\\s*${escapedShadeName}\\s*\\|\\s*Gallery\\s+image\\s+(\\d+)\\s*$`, 'i');
      const matched = this.productImages
        .map((image, sourceIndex) => {
          const match = String(image.alt || '').match(galleryAltPattern);
          return match ? { image, sourceIndex, galleryOrder: Number(match[1]) } : null;
        })
        .filter(Boolean)
        .sort((a, b) => a.galleryOrder - b.galleryOrder || a.sourceIndex - b.sourceIndex);
      const unique = matched.filter(({ image }, index, images) => images.findIndex((candidate) => candidate.image.url === image.url) === index);
      return unique.map(({ image }) => ({
        kind: 'shopify',
        src: image.url,
        alt: image.alt,
        fit: 'shopify',
      }));
    }

    fallbackGalleryItems() {
      const s = this.selected;
      return [
        { kind: 'dynamic', fit: 'dynamic', src: this.asset('product-horizontal-cutout.png'), alt: `${s.name} Smoke X shade campaign` },
        { kind: 'image', fit: 'contain', src: this.asset('product-diagonal-cutout.png'), alt: 'Smoke X Colour Kajal product detail' },
        { kind: 'image', fit: 'cover', src: this.asset('tip-close.jpg'), alt: 'Smoke X kajal tip close-up' },
        { kind: 'image', fit: 'cover', src: this.asset('eye-campaign.png'), alt: 'Smoke X eye look' },
        { kind: 'image', fit: 'contain', src: this.asset('package-range.jpg'), alt: 'Smoke X shade range and packaging' },
      ];
    }

    renderGalleryThumbs() {
      const thumbs = this.root.querySelector('.gallery-thumbs');
      if (!thumbs) return;
      const s = this.selected;
      thumbs.hidden = this.currentGalleryItems.length === 0;
      thumbs.innerHTML = this.currentGalleryItems.map((item, index) => {
        const content = item.kind === 'dynamic'
          ? `<span class="gallery-dynamic-thumb" style="background:${s.color};color:${s.ink}"><img src="${escapeHtml(item.src)}" alt=""><b>${s.n}</b></span>`
          : `<img src="${escapeHtml(item.src)}" alt="">`;
        return `<button type="button" data-gallery-index="${index}" aria-label="Show image ${index + 1}">${content}</button>`;
      }).join('');
    }

    refreshGallery() {
      const variantImages = this.variantGalleryImages();
      this.currentGalleryItems = variantImages.length ? variantImages : this.fallbackGalleryItems();
      const primary = variantImages[0] || { src: this.asset('product-horizontal-cutout.png'), alt: `${this.selected.name} Smoke X Colour Kajal` };
      this.root.querySelectorAll('.selected-shade-image img, .mobile-buy-product>img').forEach((image) => {
        image.src = primary.src;
        image.alt = primary.alt;
      });
      this.renderGalleryThumbs();
      this.setGallery(0);
    }

    setGallery(index) {
      const items = this.currentGalleryItems;
      if (!items.length) return;
      this.galleryIndex = (index + items.length) % items.length;
      const thumbs = [...this.root.querySelectorAll('.gallery-thumbs button')];
      thumbs.forEach((thumb, i) => thumb.classList.toggle('active', i === this.galleryIndex));
      const thumbRail = this.root.querySelector('.gallery-thumbs');
      const activeThumb = thumbs[this.galleryIndex];
      if (thumbRail && activeThumb) {
        const activeLeft = activeThumb.offsetLeft;
        const activeRight = activeLeft + activeThumb.offsetWidth;
        const visibleLeft = thumbRail.scrollLeft;
        const visibleRight = visibleLeft + thumbRail.clientWidth;
        if (activeLeft < visibleLeft) thumbRail.scrollTo({ left: activeLeft, behavior: 'smooth' });
        else if (activeRight > visibleRight) thumbRail.scrollTo({ left: activeRight - thumbRail.clientWidth, behavior: 'smooth' });
      }
      const counter = this.root.querySelector('.gallery-control-bar > span');
      if (counter) counter.innerHTML = `<b>${String(this.galleryIndex + 1).padStart(2, '0')}</b> / ${String(items.length).padStart(2, '0')}`;
      const frame = this.root.querySelector('.gallery-frame');
      if (!frame) return;
      const s = this.selected;
      const item = items[this.galleryIndex];
      frame.className = `gallery-frame gallery-fit-${item.fit} is-changing`;
      frame.innerHTML = item.kind === 'dynamic'
        ? `<div class="gallery-shade-creative" style="background:${s.color};color:${s.ink}"><span>${s.n} / 07 · ${s.mood}</span><h2>${s.name}</h2><i></i><img src="${escapeHtml(item.src)}" alt="${escapeHtml(item.alt)}"></div>`
        : `<img src="${escapeHtml(item.src)}" alt="${escapeHtml(item.alt)}">`;
      window.setTimeout(() => frame.classList.remove('is-changing'), 420);
    }

    toggleMenu(force) {
      const menu = this.root.querySelector('.mobile-menu');
      const trigger = this.root.querySelector('.menu-trigger');
      if (!menu || !trigger) return;
      const open = typeof force === 'boolean' ? force : !menu.classList.contains('is-open');
      menu.classList.toggle('is-open', open); trigger.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', String(!open)); trigger.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
    }

    toggleCart(open) {
      this.root.querySelector('.cart-drawer')?.classList.toggle('is-open', open);
      this.root.querySelector('.cart-backdrop')?.classList.toggle('is-open', open);
      this.root.querySelector('.cart-drawer')?.setAttribute('aria-hidden', String(!open));
      document.body.classList.toggle('cart-open', open);
      if (open) this.refreshCart();
    }

    async addToCart(goToCheckout, button) {
      const variant = this.variantForShade();
      const isGeneric = this.root.hasAttribute('data-feeo-generic-product');
      const selectionLabel = isGeneric
        ? (this.root.dataset.productTitle || 'Product')
        : (this.comboSelected ? (this.combo?.labels?.all_seven || 'All 7 Smoke X shades') : this.selected.name);
      if (!variant.id) { this.toast(isGeneric ? 'Choose a product in the theme editor first.' : 'Choose the Smoke X product in the theme editor first.'); return; }
      button?.setAttribute('aria-busy', 'true');
      try {
        if (goToCheckout) {
          await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } });
        }
        const item = { id: variant.id, quantity: this.quantity };
        if (!isGeneric) item.properties = { Shade: selectionLabel };
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(item),
        });
        if (!response.ok) throw new Error((await response.json()).description || 'Could not add this item.');
        await this.refreshCart();
        if (goToCheckout) {
          if (typeof handleFloCheckoutBtn === 'function') handleFloCheckoutBtn();
          else window.location.href = '/checkout';
        } else {
          this.toggleCart(true);
          this.toast(`${selectionLabel} added to your bag.`);
        }
      } catch (error) { this.toast(error.message || 'Could not add this item.'); }
      finally { button?.removeAttribute('aria-busy'); }
    }

    async addShadeCardToCart(button) {
      if (!button || button.getAttribute('aria-busy') === 'true') return;
      const shadeName = button.dataset.feeoShadeAdd || '';
      const shadeKey = normal(shadeName);
      const shade = shades.find((item) => normal(item.name) === shadeKey);
      const variant = this.variants.find((item) => normal(`${item.title} ${item.option1}`).includes(shadeKey));
      const icon = button.querySelector('[data-feeo-shade-add-icon]');
      const initialLabel = button.getAttribute('aria-label') || '';
      if (!variant?.id) {
        this.toast('This shade is not available right now.');
        return;
      }

      if (shade) {
        this.comboSelected = false;
        this.selected = shade;
        this.galleryIndex = 0;
        this.renderShade();
      }

      button.setAttribute('aria-busy', 'true');
      if (icon) icon.textContent = '…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: 1, properties: { Shade: shadeName } }),
        });
        if (!response.ok) throw new Error((await response.json()).description || 'Could not add this shade.');
        await this.refreshCart();
        button.classList.add('is-added');
        button.setAttribute('aria-label', button.dataset.feeoShadeAdded || `${shadeName} added to your bag`);
        if (icon) icon.textContent = '✓';
        this.toggleCart(true);
        this.toast(`${shadeName} added to your bag.`);
      } catch (error) {
        if (icon) icon.textContent = '!';
        this.toast(error.message || 'Could not add this shade.');
      } finally {
        window.setTimeout(() => {
          button.removeAttribute('aria-busy');
          button.classList.remove('is-added');
          button.setAttribute('aria-label', initialLabel);
          if (icon) icon.textContent = '+';
        }, 1100);
      }
    }

    async syncGiftCampaign(cart) {
      const campaign = this.giftCampaign;
      if (!campaign?.enabled || !campaign.qualifyingProductId || !campaign.giftVariantId || this.giftSyncing) return cart;

      const qualifyingQuantity = cart.items.reduce((total, item) => (
        String(item.product_id) === String(campaign.qualifyingProductId)
          ? total + Number(item.quantity || 0)
          : total
      ), 0);
      const giftLines = cart.items.filter((item) => (
        String(item.variant_id) === String(campaign.giftVariantId)
        && item.properties?._feeo_gift_campaign === campaign.key
      ));

      this.giftSyncing = true;
      try {
        if (qualifyingQuantity > 0 && giftLines.length === 0) {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{
                id: campaign.giftVariantId,
                quantity: 1,
                properties: { _feeo_gift_campaign: campaign.key },
              }],
            }),
          });
          if (!response.ok) return cart;
          return await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((res) => res.json());
        }

        if (qualifyingQuantity === 0 && giftLines.length > 0) {
          const updates = {};
          giftLines.forEach((item) => { updates[item.key] = 0; });
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates }),
          });
          return response.ok ? await response.json() : cart;
        }

        const incorrectGift = giftLines.find((item) => Number(item.quantity) !== 1);
        if (qualifyingQuantity > 0 && incorrectGift) {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: incorrectGift.key, quantity: 1 }),
          });
          return response.ok ? await response.json() : cart;
        }
      } catch (_) {
        return cart;
      } finally {
        this.giftSyncing = false;
      }
      return cart;
    }

    async refreshCart() {
      try {
        let cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((res) => res.json());
        cart = await this.syncGiftCampaign(cart);
        this.renderCart(cart);
      } catch (_) {}
    }

    renderCart(cart) {
      this.root.querySelectorAll('.bag-button').forEach((button) => {
        button.setAttribute('aria-label', `Bag with ${cart.item_count} items`);
        let badge = button.querySelector('b');
        if (!badge) { badge = document.createElement('b'); button.appendChild(badge); }
        badge.textContent = String(cart.item_count);
        badge.hidden = cart.item_count === 0;
      });

      const body = this.root.querySelector('.cart-body');
      const checkout = this.root.querySelector('.cart-foot > button');
      const countLabel = this.root.querySelector('[data-cart-count]');
      const mrpValue = this.root.querySelector('[data-cart-mrp]');
      const productSavingsValue = this.root.querySelector('[data-cart-product-savings]');
      const productSavingsRow = this.root.querySelector('[data-cart-product-savings-row]');
      const discountList = this.root.querySelector('[data-cart-discounts]');
      const sellingSubtotalValue = this.root.querySelector('[data-cart-selling-subtotal]');
      const estimatedTotalValue = this.root.querySelector('.cart-estimated-total > strong');

      const isComboItem = (item) => {
        if (!this.combo) return false;
        const itemKey = normal(`${item.handle || ''} ${item.product_title || ''} ${item.variant_title || ''} ${item.properties?.Shade || ''}`);
        return String(item.variant_id) === String(this.combo.id)
          || itemKey.includes(normal(this.combo.handle || ''))
          || itemKey.includes(normal(this.combo.labels?.all_seven || 'All 7 Smoke X shades'));
      };
      const variantForItem = (item) => {
        if (isComboItem(item)) return this.combo;
        const byId = this.variants.find((variant) => String(variant.id) === String(item.variant_id));
        if (byId) return byId;
        const itemKey = normal(`${item.variant_title || ''} ${item.properties?.Shade || ''}`);
        return this.variants.find((variant) => itemKey.includes(normal(`${variant.title || ''} ${variant.option1 || ''}`)))
          || this.variants.find((variant) => itemKey.includes(normal(variant.title)))
          || null;
      };
      const isCampaignGift = (item) => Boolean(
        this.giftCampaign
        && String(item.variant_id) === String(this.giftCampaign.giftVariantId)
        && item.properties?._feeo_gift_campaign === this.giftCampaign.key
      );
      const comboInCart = cart.items.some(isComboItem);
      const comboPrice = Number(this.combo?.price || 0);
      const comboCompareAt = Number(this.combo?.compare_at_price || 0);
      const comboSaving = Math.max(0, comboCompareAt - comboPrice);
      const comboUpsell = this.combo?.id && this.combo.available && !comboInCart
        ? `<article class="cart-combo-upsell">
            <span class="feeo-combo-spectrum" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i><i></i></span>
            <div class="cart-combo-upsell-head"><small>${escapeHtml(this.combo.labels?.best_value || 'Best value')}</small><b>${escapeHtml(this.combo.labels?.wardrobe || 'Complete the colour wardrobe')}</b></div>
            <div class="cart-combo-upsell-copy">
              <span>${escapeHtml(this.combo.labels?.all_seven || 'All 7 Smoke X shades')} · ${money(comboPrice / 7)} each</span>
              <span><s>${money(comboCompareAt)}</s><strong>${money(comboPrice)}</strong><em>${escapeHtml(this.combo.labels?.save || 'Save')} ${money(comboSaving)}</em></span>
            </div>
            <button type="button" data-feeo-combo-add>${escapeHtml(this.combo.labels?.add_set || 'Add full set')}</button>
          </article>`
        : '';
      const relatedUrl = this.root.dataset.relatedProductUrl || '';
      const relatedHandle = relatedUrl.split('/products/')[1]?.split(/[?#]/)[0] || '';
      const relatedInCart = relatedHandle && cart.items.some((item) => item.handle === relatedHandle);
      const relatedCard = relatedUrl && !relatedInCart
        ? `<a class="cart-product-discovery" href="${escapeHtml(relatedUrl)}">
            ${this.root.dataset.relatedProductImage ? `<img src="${escapeHtml(this.root.dataset.relatedProductImage)}" alt="">` : ''}
            <span><small>COMPLETE THE EYE LOOK</small><b>${escapeHtml(this.root.dataset.relatedProductTitle || 'Discover another FEEO product')}</b><em>${escapeHtml(this.root.dataset.relatedProductPrice || '')}</em></span>
            <strong aria-hidden="true">↗</strong>
          </a>`
        : '';

      const sellingSubtotal = cart.items.reduce((sum, item) => {
        const unitPrice = Number(item.original_price ?? item.price ?? 0);
        return sum + (unitPrice * Number(item.quantity || 0));
      }, 0);
      const mrpTotal = cart.items.reduce((sum, item) => {
        const variant = variantForItem(item);
        const unitPrice = Number(item.original_price ?? item.price ?? 0);
        const compareAt = Number(variant?.compare_at_price || 0);
        return sum + ((compareAt > unitPrice ? compareAt : unitPrice) * Number(item.quantity || 0));
      }, 0);
      const productSavings = Math.max(0, mrpTotal - sellingSubtotal);
      const estimatedTotal = Number(cart.total_price || 0);
      const additionalDiscount = Math.max(0, sellingSubtotal - estimatedTotal);
      const appliedDiscounts = new Map();
      const addDiscount = (application, amount) => {
        const title = String(application?.title || '').trim();
        const allocatedAmount = Math.max(0, Number(amount || 0));
        if (!title || allocatedAmount <= 0) return;
        const key = normal(title);
        const current = appliedDiscounts.get(key);
        appliedDiscounts.set(key, {
          title,
          amount: allocatedAmount + Number(current?.amount || 0),
        });
      };

      (cart.cart_level_discount_applications || []).forEach((application) => {
        addDiscount(application, application.total_allocated_amount ?? application.amount);
      });
      cart.items.forEach((item) => {
        const allocations = Array.isArray(item.line_level_discount_allocations)
          ? item.line_level_discount_allocations
          : [];
        if (allocations.length) {
          allocations.forEach((allocation) => addDiscount(allocation.discount_application, allocation.amount));
          return;
        }
        (item.discounts || []).forEach((discount) => addDiscount(discount, discount.amount));
      });

      const namedDiscounts = [...appliedDiscounts.values()];
      const namedDiscountTotal = namedDiscounts.reduce((sum, discount) => sum + discount.amount, 0);
      const unnamedDiscount = Math.max(0, additionalDiscount - namedDiscountTotal);
      const offerAppliedLabel = discountList?.dataset.offerLabel || 'Offer applied';
      const additionalDiscountLabel = discountList?.dataset.additionalLabel || 'Additional discount';
      const shopifyDiscountLabel = discountList?.dataset.shopifyLabel || 'Shopify discount';
      const discountRows = namedDiscounts.map((discount) => ({
        title: discount.title,
        amount: discount.amount,
        named: true,
      }));
      if (unnamedDiscount > 0) discountRows.push({ title: additionalDiscountLabel, amount: unnamedDiscount, named: false });

      if (countLabel) countLabel.textContent = cart.item_count === 1 ? '1 item · Ready when you are' : `${cart.item_count} items · Ready when you are`;
      if (mrpValue) mrpValue.textContent = money(mrpTotal);
      if (productSavingsValue) productSavingsValue.textContent = `−${money(productSavings)}`;
      if (productSavingsRow) productSavingsRow.hidden = productSavings <= 0;
      if (discountList) {
        discountList.innerHTML = discountRows.map((discount) => `<div class="cart-discount-row">
          <span class="cart-discount-label">
            <i aria-hidden="true">✓</i>
            <span><strong>${escapeHtml(discount.title)}</strong><small>${escapeHtml(discount.named ? offerAppliedLabel : shopifyDiscountLabel)}</small></span>
          </span>
          <b>−${money(discount.amount)}</b>
        </div>`).join('');
        discountList.hidden = discountRows.length === 0;
      }
      if (sellingSubtotalValue) sellingSubtotalValue.textContent = money(sellingSubtotal);
      if (estimatedTotalValue) estimatedTotalValue.textContent = money(estimatedTotal);
      if (checkout) {
        checkout.disabled = cart.item_count === 0;
        checkout.textContent = cart.item_count ? `Secure checkout · ${money(estimatedTotal)}` : 'Secure checkout';
        checkout.onclick = () => {
          if (typeof handleFloCheckoutBtn === 'function') { handleFloCheckoutBtn(); }
          else { window.location.href = '/checkout'; }
        };
      }

      if (!body) return;
      if (!cart.items.length) {
        body.innerHTML = `<div class="cart-empty"><span>FEEO BEAUTY</span><h2>YOUR BAG IS<br>READY FOR A LOOK.</h2><p>Start with the product you came for, or explore the complete eye range.</p><a href="${this.root.dataset.productUrl || '/collections/all'}" class="button button-blue">Shop this product</a></div>${relatedCard}${comboUpsell}`;
        body.querySelectorAll('[data-feeo-combo-add]').forEach((button) => button.addEventListener('click', () => this.addComboToCart(button)));
        return;
      }

      body.innerHTML = cart.items.map((item, index) => {
        const isCombo = isComboItem(item);
        const isGift = isCampaignGift(item);
        const shadeName = isCombo
          ? (this.combo?.labels?.all_seven || 'All 7 Smoke X shades')
          : (item.properties?.Shade || item.variant_title || 'Smoke X');
        const shade = isCombo ? null : (shades.find((entry) => normal(shadeName).includes(normal(entry.name))) || shades[3]);
        const image = item.image || item.featured_image?.url || (isCombo ? this.combo?.image : '') || this.asset('product-horizontal-cutout.png');
        const variant = variantForItem(item);
        const unitPrice = Number(item.original_price ?? item.price ?? 0);
        const compareAt = Number(variant?.compare_at_price || 0);
        const unitSaving = Math.max(0, compareAt - unitPrice);
        const lineTotal = isGift ? Number(item.final_line_price || 0) : unitPrice * Number(item.quantity || 0);
        const saleMeta = isGift
          ? `<s>${money(unitPrice)}</s><em class="cart-gift-label">FREE GIFT</em>`
          : unitSaving > 0
          ? `<s>${money(compareAt)}</s><em>Save ${money(unitSaving)}</em>`
          : '';
        return `<article class="cart-item${isCombo ? ' is-combo' : ''}${isGift ? ' is-campaign-gift' : ''}">
          <div class="cart-item-visual${isCombo ? ' cart-item-combo-visual' : ''}"${isCombo ? '' : ` style="background:${shade.color};color:${shade.ink}"`}>
            <img src="${escapeHtml(image)}" alt="${escapeHtml(isCombo ? (this.combo?.labels?.full_set || 'Full Spectrum Set') : `${shade.name} Smoke X`)}">
          </div>
          <div class="cart-item-copy">
            <div class="cart-item-top">
              <small><span>${isGift ? 'COMPLIMENTARY GIFT' : isCombo ? escapeHtml(this.combo?.labels?.set_label || '7 shade set') : 'Shade'}</span>${escapeHtml(isGift ? (this.giftCampaign?.giftMessage || 'Free with FEEO MATTES') : isCombo ? (this.combo?.labels?.all_seven || 'All 7 Smoke X shades') : shade.name)}</small>
              ${isGift ? '' : `<button type="button" class="cart-item-remove" aria-label="Remove ${escapeHtml(shadeName)}" data-cart-change="${index + 1}" data-qty="0">×</button>`}
            </div>
            <h3>${escapeHtml(item.product_title)}</h3>
            <div class="cart-item-pricing">
              <span>Unit price</span>
              <div><strong>${isGift ? 'FREE' : money(unitPrice)}</strong>${saleMeta}</div>
            </div>
            <div class="cart-item-bottom">
              ${isGift ? `<span class="cart-gift-label">Added automatically · Qty 1</span>` : `<div class="cart-quantity" aria-label="Quantity for ${escapeHtml(shadeName)}">
                <button type="button" aria-label="Decrease quantity" data-cart-change="${index + 1}" data-qty="${Math.max(0, item.quantity - 1)}">−</button>
                <span>${item.quantity}</span>
                <button type="button" aria-label="Increase quantity" data-cart-change="${index + 1}" data-qty="${item.quantity + 1}">+</button>
              </div>`}
              <div class="cart-item-line-total"><span>Item total</span><b>${money(lineTotal)}</b></div>
            </div>
          </div>
        </article>`;
      }).join('') + relatedCard + comboUpsell;
      body.querySelectorAll('[data-feeo-combo-add]').forEach((button) => button.addEventListener('click', () => this.addComboToCart(button)));
      body.querySelectorAll('[data-cart-change]').forEach((button) => button.addEventListener('click', () => this.changeCart(button.dataset.cartChange, button.dataset.qty)));
    }

    async changeCart(line, quantity) {
      const drawer = this.root.querySelector('.cart-drawer'); drawer?.classList.add('is-loading');
      try {
        let cart = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }) }).then((res) => res.json());
        cart = await this.syncGiftCampaign(cart);
        this.renderCart(cart);
      } finally { drawer?.classList.remove('is-loading'); }
    }

    setupHomeHeroAutoplay() {
      const rail = this.root.querySelector('.home-hero .hero-shades');
      const visual = this.root.querySelector('.home-hero .hero-visual');
      if (!rail || !visual || shades.length < 2) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const interval = 2500;
      let timer = null;
      let inView = true;

      const keepActiveShadeVisible = () => {
        const active = rail.querySelector('button.active');
        if (!active) return;

        if (rail.scrollWidth > rail.clientWidth + 2) {
          const left = active.offsetLeft - ((rail.clientWidth - active.offsetWidth) / 2);
          rail.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        } else if (rail.scrollHeight > rail.clientHeight + 2) {
          const top = active.offsetTop - ((rail.clientHeight - active.offsetHeight) / 2);
          rail.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        }
      };

      const advance = () => {
        this.comboSelected = false;
        const current = Math.max(0, shades.findIndex((shade) => normal(shade.name) === normal(this.selected.name)));
        this.selected = shades[(current + 1) % shades.length];
        this.galleryIndex = 0;
        this.renderShade();
        keepActiveShadeVisible();
      };

      const stop = () => {
        window.clearInterval(timer);
        timer = null;
      };

      const start = () => {
        stop();
        if (!reduceMotion && inView && document.visibilityState !== 'hidden') {
          timer = window.setInterval(advance, interval);
        }
      };

      rail.addEventListener('click', () => {
        keepActiveShadeVisible();
        start();
      });

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') stop();
        else start();
      });

      const observer = new IntersectionObserver((entries) => {
        inView = entries.some((entry) => entry.isIntersecting);
        if (inView) start();
        else stop();
      }, { threshold: 0.12 });
      observer.observe(visual);

      keepActiveShadeVisible();
      start();
    }

    setupShoppableVideos() {
      this.root.querySelectorAll('[data-shoppable-videos]').forEach((section) => {
        const viewport = section.querySelector('[data-video-viewport]');
        const cards = [...section.querySelectorAll('[data-video-card]')];
        if (!viewport || !cards.length) return;

        const previous = section.querySelector('[data-video-prev]');
        const next = section.querySelector('[data-video-next]');
        const currentLabel = section.querySelector('[data-video-current]');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const autoplay = section.dataset.videoAutoplay === 'true' && !reduceMotion;
        let current = 0;
        let scrollTimer = null;
        let sectionVisible = false;

        const setPlaybackState = (card, playing) => {
          card.classList.toggle('is-playing', playing);
          if (playing) card.classList.add('has-started');
          const button = card.querySelector('[data-video-toggle]');
          if (button) {
            button.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} video`);
            const label = button.querySelector('span');
            if (label) label.textContent = playing ? 'Pause' : 'Play';
          }
        };

        const pauseCard = (card) => {
          const video = card.querySelector('video');
          if (!video) return;
          video.pause();
          setPlaybackState(card, false);
        };

        const playCard = (card) => {
          const video = card.querySelector('video');
          if (!video) return;
          cards.forEach((other) => { if (other !== card) pauseCard(other); });
          const promise = video.play();
          if (promise?.catch) promise.catch(() => {});
          setPlaybackState(card, true);
        };

        const updateCurrent = (index, scroll = false) => {
          current = Math.max(0, Math.min(cards.length - 1, index));
          cards.forEach((card, cardIndex) => {
            card.classList.toggle('is-current', cardIndex === current);
            if (cardIndex !== current) pauseCard(card);
          });
          if (currentLabel) currentLabel.textContent = String(current + 1).padStart(2, '0');
          if (previous) previous.disabled = current === 0;
          if (next) next.disabled = current === cards.length - 1;
          if (scroll) viewport.scrollTo({ left: cards[current].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
          if (autoplay && sectionVisible) playCard(cards[current]);
        };

        const nearestCard = () => {
          const left = viewport.scrollLeft;
          let nearest = 0;
          let distance = Infinity;
          cards.forEach((card, index) => {
            const nextDistance = Math.abs(card.offsetLeft - left);
            if (nextDistance < distance) { distance = nextDistance; nearest = index; }
          });
          return nearest;
        };

        previous?.addEventListener('click', () => updateCurrent(current - 1, true));
        next?.addEventListener('click', () => updateCurrent(current + 1, true));
        viewport.addEventListener('scroll', () => {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(() => updateCurrent(nearestCard()), 90);
        }, { passive: true });

        cards.forEach((card, index) => {
          card.querySelector('[data-video-toggle]')?.addEventListener('click', () => {
            updateCurrent(index);
            const video = card.querySelector('video');
            if (!video) return;
            if (video.paused) playCard(card);
            else pauseCard(card);
          });
          card.querySelector('[data-video-sound]')?.addEventListener('click', () => {
            const video = card.querySelector('video');
            const button = card.querySelector('[data-video-sound]');
            if (!video || !button) return;
            video.muted = !video.muted;
            button.classList.toggle('is-unmuted', !video.muted);
            button.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Mute video');
            if (video.paused) playCard(card);
          });
          card.querySelector('[data-feeo-video-add]')?.addEventListener('click', (event) => {
            const button = event.currentTarget;
            this.addShoppableVideoToCart(button.dataset.variantId, button.dataset.shadeName, button);
          });
        });

        const observer = new IntersectionObserver((entries) => {
          sectionVisible = entries.some((entry) => entry.isIntersecting);
          if (sectionVisible && autoplay) playCard(cards[current]);
          if (!sectionVisible) cards.forEach(pauseCard);
        }, { threshold: 0.22 });
        observer.observe(section);
        updateCurrent(0);
      });
    }

    async addShoppableVideoToCart(variantId, shadeName, button) {
      if (!variantId || button?.getAttribute('aria-busy') === 'true') return;
      button?.setAttribute('aria-busy', 'true');
      const originalLabel = button?.textContent;
      if (button) button.textContent = 'Adding...';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: String(variantId), quantity: 1, properties: { Shade: shadeName } }),
        });
        if (!response.ok) throw new Error((await response.json()).description || 'Could not add this shade.');
        await this.refreshCart();
        this.toggleCart(true);
        this.toast(`${shadeName} added to your bag.`);
      } catch (error) {
        this.toast(error.message || 'Could not add this shade.');
      } finally {
        button?.removeAttribute('aria-busy');
        if (button && originalLabel) button.textContent = originalLabel;
      }
    }

    setupBannerSlider() {
      const slider = this.root.querySelector('[data-product-banner-slider]');
      if (!slider) return;

      const slides = [...slider.querySelectorAll('[data-banner-slide]')];
      const dots = [...slider.querySelectorAll('[data-banner-dot]')];
      if (!slides.length) return;

      let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let timer = null;
      let touchStartX = 0;
      const interval = Math.max(2000, Number(slider.dataset.interval) || 3000);
      const autoplay = slider.dataset.autoplay === 'true' && slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
      };

      const stop = () => {
        window.clearInterval(timer);
        timer = null;
      };

      const start = () => {
        stop();
        if (autoplay && document.visibilityState !== 'hidden') timer = window.setInterval(() => show(current + 1), interval);
      };

      const go = (index) => {
        show(index);
        start();
      };

      slider.querySelector('[data-banner-prev]')?.addEventListener('click', () => go(current - 1));
      slider.querySelector('[data-banner-next]')?.addEventListener('click', () => go(current + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => go(Number(dot.dataset.bannerDot))));

      slider.addEventListener('pointerenter', stop);
      slider.addEventListener('pointerleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', () => window.setTimeout(() => {
        if (!slider.contains(document.activeElement)) start();
      }, 0));
      slider.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0]?.clientX || 0;
        stop();
      }, { passive: true });
      slider.addEventListener('touchend', (event) => {
        const distance = (event.changedTouches[0]?.clientX || 0) - touchStartX;
        if (Math.abs(distance) > 45) show(current + (distance < 0 ? 1 : -1));
        start();
      }, { passive: true });
      document.addEventListener('visibilitychange', () => document.visibilityState === 'hidden' ? stop() : start());
      document.addEventListener('shopify:block:select', (event) => {
        const selected = slides.findIndex((slide) => slide.dataset.blockId === event.detail?.blockId);
        if (selected >= 0) { show(selected); stop(); }
      });

      show(current);
      start();
    }

    setupReviews() {
      const reviews = this.root.querySelector('[data-reviews-root]');
      if (!reviews) return;

      this.setupReviewCarousel(reviews);
      const modal = reviews.querySelector('[data-review-modal]');
      if (!modal) return;

      let previouslyFocused = null;
      const panel = modal.querySelector('.review-modal-panel');
      const open = () => {
        previouslyFocused = document.activeElement;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('review-open');
        window.setTimeout(() => panel?.querySelector('input:not([type="hidden"]), select, textarea, button')?.focus(), 30);
      };
      const close = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('review-open');
        previouslyFocused?.focus?.();
      };

      const successKey = `feeo-review-success:${window.location.pathname}`;

      reviews.querySelectorAll('[data-review-open]').forEach((button) => button.addEventListener('click', () => {
        try { window.sessionStorage.removeItem(successKey); } catch (error) { /* Storage can be unavailable in privacy mode. */ }
        open();
      }));
      modal.querySelectorAll('[data-review-close]').forEach((button) => button.addEventListener('click', close));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) close();
      });

      const success = modal.querySelector('[data-review-success]');
      if (success) {
        let alreadyShown = false;
        try {
          alreadyShown = window.sessionStorage.getItem(successKey) === 'shown';
          window.sessionStorage.setItem(successKey, 'shown');
        } catch (error) { /* The URL cleanup below still prevents repeat success screens. */ }

        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('contact_posted');
        if (/FeeoReviewForm|contact_form/i.test(cleanUrl.hash)) cleanUrl.hash = '';
        window.history.replaceState({}, document.title, `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
        if (!alreadyShown) open();
      } else if (modal.querySelector('.errors')) open();
    }

    setupContactSuccess() {
      const success = this.root.querySelector('.feeo-form-success');
      if (!success) return;
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('contact_posted');
      if (/FeeoContactForm|contact_form/i.test(cleanUrl.hash)) cleanUrl.hash = '';
      window.history.replaceState({}, document.title, `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
    }

    setupReviewCarousel(reviews) {
      const carousel = reviews.querySelector('[data-review-carousel]');
      const track = carousel?.querySelector('[data-review-track]');
      const cards = track ? [...track.querySelectorAll('.customer-review-card:not(.customer-review-placeholder)')] : [];
      if (!carousel || !track || cards.length <= 3) return;

      const clones = cards.map((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => element.removeAttribute('data-shopify-editor-block'));
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => element.setAttribute('tabindex', '-1'));
        track.appendChild(clone);
        return clone;
      });

      let loopWidth = 0;
      let frame = null;
      let previousTime = 0;
      let autoPosition = 0;
      let paused = false;
      let pauseUntil = 0;
      let dragStartX = 0;
      let dragStartScroll = 0;
      let dragging = false;
      const measure = () => {
        loopWidth = clones[0]?.offsetLeft - cards[0]?.offsetLeft || 0;
      };
      const normalise = () => {
        if (!loopWidth) return;
        while (track.scrollLeft >= loopWidth) track.scrollLeft -= loopWidth;
        while (track.scrollLeft < 0) track.scrollLeft += loopWidth;
        autoPosition = track.scrollLeft;
      };
      const pauseFor = (duration = 1800) => {
        pauseUntil = Math.max(pauseUntil, performance.now() + duration);
      };
      const tick = (time) => {
        if (!this.root.isConnected) {
          frame = null;
          return;
        }
        if (!previousTime) previousTime = time;
        const elapsed = Math.min(time - previousTime, 64);
        previousTime = time;
        if (!paused && time >= pauseUntil && document.visibilityState !== 'hidden') {
          autoPosition += elapsed * 0.06;
          if (loopWidth && autoPosition >= loopWidth) autoPosition -= loopWidth;
          track.scrollLeft = autoPosition;
        }
        frame = window.requestAnimationFrame(tick);
      };
      const step = (direction) => {
        measure();
        normalise();
        if (direction < 0 && track.scrollLeft < cards[0].offsetWidth) track.scrollLeft += loopWidth;
        const gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 14;
        track.scrollBy({ left: direction * (cards[0].offsetWidth + gap), behavior: 'smooth' });
        pauseFor(2200);
      };

      carousel.querySelector('[data-review-prev]')?.addEventListener('click', () => step(-1));
      carousel.querySelector('[data-review-next]')?.addEventListener('click', () => step(1));
      carousel.addEventListener('focusin', () => pauseFor(2800));
      track.addEventListener('wheel', () => pauseFor(1800), { passive: true });
      track.addEventListener('scroll', () => {
        if (paused || dragging || performance.now() < pauseUntil) autoPosition = track.scrollLeft;
      }, { passive: true });
      track.addEventListener('touchstart', () => { paused = true; }, { passive: true });
      track.addEventListener('touchend', () => {
        pauseFor(2200);
        paused = false;
      }, { passive: true });
      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        paused = true;
        dragStartX = event.clientX;
        dragStartScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });
      track.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        event.preventDefault();
        track.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
        autoPosition = track.scrollLeft;
      });
      const endDrag = (event) => {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        normalise();
        pauseFor(2200);
        paused = false;
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      window.addEventListener('resize', () => {
        measure();
        normalise();
      });

      measure();
      autoPosition = track.scrollLeft;
      frame = window.requestAnimationFrame(tick);
    }

    setupMotion() {
      document.body.classList.add('motion-ready');
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('in-view'); observer.unobserve(entry.target); }
      }), { threshold: 0.12 });
      this.root.querySelectorAll('[data-animate]').forEach((element) => observer.observe(element));
    }

    setupProductNav() {
      const nav = this.root.querySelector('.pdp-nav');
      if (!nav) return;
      const links = [...nav.querySelectorAll('a[href^="#"]')];
      const sections = links.map((link) => this.root.querySelector(link.getAttribute('href'))).filter(Boolean);
      const observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        links.forEach((link) => {
          const active = link.getAttribute('href') === `#${visible.target.id}`;
          link.classList.toggle('active', active);
          if (active) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current');
        });
      }, { rootMargin: '-20% 0px -65% 0px', threshold: [0, 0.1, 0.25] });
      sections.forEach((section) => observer.observe(section));
    }

    toast(message) {
      const toast = this.root.querySelector('.toast'); if (!toast) return;
      toast.textContent = message; toast.classList.add('show');
      clearTimeout(this.toastTimer); this.toastTimer = setTimeout(() => toast.classList.remove('show'), 2600);
    }
  }

  const setupFloatingVideo = () => {
    document.querySelectorAll('[data-feeo-floating-video]').forEach((widget) => {
      if (widget.dataset.floatingVideoReady === 'true') return;
      widget.dataset.floatingVideoReady = 'true';

      const video = widget.querySelector('[data-floating-video-player]');
      const stage = widget.querySelector('[data-floating-video-stage]');
      const modal = widget.querySelector('[data-floating-video-modal]');
      const modalMedia = widget.querySelector('[data-floating-video-modal-media]');
      const expandButton = widget.querySelector('[data-floating-video-expand]');
      const modalCloseButton = widget.querySelector('.feeo-floating-video-modal-close');
      const soundButtons = [...widget.querySelectorAll('[data-floating-video-sound]')];
      if (!video || !stage || !modal || !modalMedia) return;

      const storageKey = `feeo-floating-video-dismissed-${widget.dataset.videoId || 'default'}`;
      const oncePerSession = widget.dataset.oncePerSession !== 'false';
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const delay = Math.max(0, Number(widget.dataset.delay) || 0);
      let returnFocus = null;

      const wasDismissed = () => {
        if (!oncePerSession) return false;
        try { return window.sessionStorage.getItem(storageKey) === 'true'; }
        catch (_) { return false; }
      };

      const rememberDismissal = () => {
        if (!oncePerSession) return;
        try { window.sessionStorage.setItem(storageKey, 'true'); }
        catch (_) {}
      };

      const updateSoundButton = () => {
        soundButtons.forEach((button) => {
          button.classList.toggle('is-unmuted', !video.muted);
          button.setAttribute('aria-label', video.muted ? 'Play with sound' : 'Mute video');
        });
      };

      const startVideo = () => {
        if (!video.currentSrc) video.load();
        if (widget.dataset.autoplay === 'true' && !reduceMotion) {
          const playback = video.play();
          if (playback?.catch) playback.catch(() => {});
        }
      };

      const show = () => {
        if (wasDismissed() || widget.classList.contains('is-dismissed')) return;
        widget.classList.add('is-visible');
        startVideo();
      };

      const collapse = () => {
        if (!widget.classList.contains('is-expanded')) return;
        widget.classList.remove('is-expanded');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('floating-video-open');
        video.controls = false;
        video.muted = true;
        stage.insertBefore(video, stage.firstChild);
        updateSoundButton();
        const playback = video.play();
        if (playback?.catch) playback.catch(() => {});
        returnFocus?.focus();
      };

      const expand = () => {
        returnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : expandButton;
        widget.classList.add('is-expanded');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('floating-video-open');
        modalMedia.appendChild(video);
        video.controls = true;
        video.muted = false;
        updateSoundButton();
        const playback = video.play();
        if (playback?.catch) playback.catch(() => {});
        modalCloseButton?.focus();
      };

      const dismiss = () => {
        collapse();
        widget.classList.remove('is-visible');
        widget.classList.add('is-dismissed');
        video.pause();
        rememberDismissal();
      };

      expandButton?.addEventListener('click', expand);
      widget.querySelector('[data-floating-video-dismiss]')?.addEventListener('click', dismiss);
      widget.querySelectorAll('[data-floating-video-collapse]').forEach((button) => button.addEventListener('click', collapse));
      soundButtons.forEach((button) => button.addEventListener('click', () => {
        video.muted = !video.muted;
        updateSoundButton();
        if (video.paused) {
          const playback = video.play();
          if (playback?.catch) playback.catch(() => {});
        }
      }));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && widget.classList.contains('is-expanded')) collapse();
      });

      updateSoundButton();
      if (!wasDismissed()) window.setTimeout(show, delay);
    });
  };

  const setupProductGalleries = (scope = document) => {
    const galleries = [];
    if (scope.matches?.('[data-product-gallery]')) galleries.push(scope);
    galleries.push(...scope.querySelectorAll('[data-product-gallery]'));

    galleries.forEach((gallery) => {
      if (gallery.dataset.productGalleryReady === 'true') return;
      const track = gallery.querySelector('[data-product-gallery-track]');
      const slides = [...gallery.querySelectorAll('[data-product-gallery-slide]')];
      if (!track || !slides.length) return;
      gallery.dataset.productGalleryReady = 'true';

      const current = gallery.querySelector('[data-product-gallery-current]');
      const total = gallery.querySelector('[data-product-gallery-total]');
      const previous = gallery.querySelector('[data-product-gallery-prev]');
      const next = gallery.querySelector('[data-product-gallery-next]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = gallery.dataset.autoplay === 'true' && !reduceMotion && slides.length > 1;
      const interval = Math.max(3000, Number(gallery.dataset.interval) || 4200);
      let index = 0;
      let timer;

      if (total) total.textContent = String(slides.length).padStart(2, '0');
      const update = () => {
        const width = track.clientWidth || 1;
        index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
        if (current) current.textContent = String(index + 1).padStart(2, '0');
      };
      const go = (nextIndex, behavior = 'smooth') => {
        index = (nextIndex + slides.length) % slides.length;
        track.scrollTo({ left: index * track.clientWidth, behavior });
        if (current) current.textContent = String(index + 1).padStart(2, '0');
      };
      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (autoplay) timer = window.setInterval(() => go(index + 1), interval);
      };

      previous?.addEventListener('click', () => { go(index - 1); start(); });
      next?.addEventListener('click', () => { go(index + 1); start(); });
      track.addEventListener('scroll', update, { passive: true });
      gallery.addEventListener('pointerenter', stop);
      gallery.addEventListener('pointerleave', start);
      gallery.addEventListener('focusin', stop);
      gallery.addEventListener('focusout', start);
      gallery.addEventListener('touchstart', stop, { passive: true });
      gallery.addEventListener('touchend', start, { passive: true });
      window.addEventListener('resize', () => go(index, 'auto'));
      update();
      start();
    });
  };

  const init = () => {
    document.querySelectorAll('[data-feeo-root]').forEach((root) => {
      if (!root.feeoStorefront) root.feeoStorefront = new FeeoStorefront(root);
    });
    setupFloatingVideo();
    setupProductGalleries();
  };

  const restorePageState = () => document.querySelectorAll('[data-feeo-root]').forEach((root) => {
    const storefront = root.feeoStorefront;
    if (!storefront) return;
    const activeButton = root.querySelector('.pdp-shades [data-feeo-shade-select].active[aria-checked="true"]');
    const label = activeButton?.querySelector('b')?.textContent;
    const restoredShade = shades.find((shade) => normal(label) === normal(shade.name));
    if (restoredShade) storefront.selected = restoredShade;
    storefront.renderShade();
    const focused = document.activeElement;
    if (focused instanceof HTMLElement && focused.matches('.pdp-shades [data-feeo-shade-select]')) focused.blur();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', (event) => {
    init();
    setupProductGalleries(event.target);
  });
  window.addEventListener('pageshow', restorePageState);
})();
